module.exports = __webpack_public_path__ + "img/avatar-1.9e13a903.jpg";